import { cx } from '@emotion/css';
import React, { useState } from 'react';
import { ix } from '../../../utils/ix';
import { Link } from '../../atoms/Link/Link';
import { Typography } from '../../electrons/Typography/Typography';
import { Banner } from '../Banner';
import useStyles from './AnalyticsBanner.styles';
export const AnalyticsBanner = (props) => {
    const styles = useStyles();
    const [marginTopClass, updateClassName] = useState(styles.marginTop);
    const { className, title, body, imageUrl, linkText, onLinkClick, onClose: providedOnClose, id, disableClosing, highlighted, hideCloseIcon, open, } = props;
    const onClose = () => {
        updateClassName('');
        if (providedOnClose) {
            providedOnClose();
        }
    };
    return (React.createElement(Banner, { id: id, className: cx(styles.analyticsBanner, marginTopClass, className), onClose: onClose, disableClosing: disableClosing, highlighted: highlighted, hideCloseIcon: hideCloseIcon, open: open },
        React.createElement("div", { className: styles.content },
            React.createElement("img", { className: styles.image, src: imageUrl }),
            React.createElement("div", null,
                React.createElement(Typography, { className: styles.header, variant: "h3" }, title),
                React.createElement(Typography, { className: styles.body, variant: "body2" },
                    body,
                    ' ',
                    React.createElement(Link, { id: ix(props.id, 'link'), onClick: onLinkClick }, linkText))))));
};
//# sourceMappingURL=AnalyticsBanner.js.map